/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectContactResponseDto } from './subjectContactResponseDto.model';
import { ParcelSearchItem } from './parcelSearchItem.model';
import { ContractSearchDto } from './contractSearchDto.model';


/**
 * Agregovaný výsledek vyhledávání rozdělený podle typu entity
 */
export interface SearchResultDto { 
    /**
     * Nalezené smlouvy
     */
    contracts?: Array<ContractSearchDto>;
    /**
     * True, pokud se smlouvy hledaly podle čísla smlouvy; false, pokud podle jména osoby
     */
    contractsMatchedByNumber?: boolean;
    /**
     * Celkový počet odpovídajících smluv bez ohledu na limit
     */
    contractsTotal?: number;
    /**
     * Nalezené parcely
     */
    parcels?: Array<ParcelSearchItem>;
    /**
     * Celkový počet odpovídajících parcel bez ohledu na limit
     */
    parcelsTotal?: number;
    /**
     * Nalezené subjekty (osoby)
     */
    subjects?: Array<SubjectContactResponseDto>;
    /**
     * Celkový počet odpovídajících subjektů (osob) bez ohledu na limit
     */
    subjectsTotal?: number;
}

